import { createContext } from 'react';

import type { ChartUnit } from '../../core/types/chart-unit.js';
import { TimeseriesDataPointAllTypes } from '../components/displays/shared/types.js';
import {
  WeakMapSeries,
  WeakMapDatapoints,
  TimeseriesSlotProps,
  TimeseriesPerVariant,
} from '../types/timeseries.js';

export interface TimeseriesFilteredData {
  dataPerVariant: TimeseriesPerVariant;
  data: TimeseriesSlotProps[];
  seriesMap: WeakMapSeries;
  datapointsMap: WeakMapDatapoints;
  units: ChartUnit[];
  originalUnits: ChartUnit[];
  allDatapoints: TimeseriesDataPointAllTypes[];
}

export const TimeseriesFilteredDataContext =
  createContext<TimeseriesFilteredData>({
    dataPerVariant: {
      area: [],
      bar: [],
      band: [],
      line: [],
      shapePriority: [],
    },
    data: [],
    units: [],
    seriesMap: new WeakMap(),
    datapointsMap: new WeakMap(),
    originalUnits: [],
    allDatapoints: [],
  });

TimeseriesFilteredDataContext['displayName'] = 'TimeseriesFilteredDataContext';
